const storageKey = 'marqueetafel_playpause';
let manualPaused = false;
try {
	manualPaused = localStorage.getItem(storageKey) === '1';
} catch (e) {}
function syncPlaypauseAll() {
	document.querySelectorAll('section.marqueetafel span.playpause').forEach((el) => {
		el.textContent = manualPaused ? 'play_circle' : 'pause_circle';
	});
}

document.querySelectorAll('section.marqueetafel a.marquee').forEach((marquee, i) => {
	const gap = getComputedStyle(marquee).gap || '1.5rem';

	const baseSpeed = 55;
	const factor = 0.35;
	const speed = baseSpeed * (1 + (Math.random() * 2 - 1) * factor);
	const startRange = 1000;

	const content = document.createElement('div');
	content.className = 'marquee-wrapper';
	content.style.display = 'inline-flex';
	content.style.alignItems = 'center';
	content.style.gap = gap;
	content.style.whiteSpace = 'nowrap';
	content.style.flex = '0 0 auto';

	while (marquee.firstChild) content.appendChild(marquee.firstChild);

	const track = document.createElement('div');
	track.className = 'marquee-track';
	track.style.display = 'inline-flex';
	track.style.alignItems = 'center';
	track.style.whiteSpace = 'nowrap';
	track.style.willChange = 'transform';
	track.style.transform = 'translate3d(0,0,0)';

	marquee.style.overflow = 'hidden';
	marquee.style.whiteSpace = 'nowrap';

	marquee.appendChild(track);

	let x = 0;
	let w = 0;
	let hoverPaused = false;
	let built = false;
	let last = performance.now();

	function ensureClones() {
		track.innerHTML = '';
		track.appendChild(content);

		w = Math.ceil(content.scrollWidth);
		const view = Math.ceil(marquee.clientWidth);
		if (!w || !view) return false;

		const minTotal = view + w + 50;
		let total = w;
		let n = 1;
		while (total < minTotal && n < 20) {
			const c = content.cloneNode(true);
			c.className = 'marquee-clone';
			track.appendChild(c);
			total += w;
			n++;
		}

		return true;
	}

	function clampXToW(prevW) {
		if (!w) return;
		if (!prevW) {
			x = -Math.min(Math.random() * startRange, w - 1);
			return;
		}
		const t = (-x % prevW + prevW) % prevW;
		x = -((t / prevW) * w);
	}

	function build() {
		const prevW = w;
		const ok = ensureClones();
		w = Math.ceil(content.scrollWidth);
		if (!ok || !w) return;
		clampXToW(prevW);
		built = true;
	}

	function tick(now) {
		const dt = Math.min(0.05, (now - last) / 1000);
		last = now;

		if (built && w) {
			if (!(manualPaused || hoverPaused)) {
				x -= speed * dt;
				while (x <= -w) x += w;
				while (x > 0) x -= w;
			}
			track.style.transform = `translate3d(${x}px,0,0)`;
		}

		requestAnimationFrame(tick);
	}

	build();

	let resizeRaf = 0;
	window.addEventListener('resize', () => {
		if (resizeRaf) cancelAnimationFrame(resizeRaf);
		resizeRaf = requestAnimationFrame(() => {
			resizeRaf = 0;
			build();
		});
	});

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(() => build());
	}

	const playpause = marquee.closest('section.marqueetafel')?.querySelector('span.playpause');
	if (playpause) {
		playpause.addEventListener('click', (e) => {
			e.preventDefault();
			manualPaused = !manualPaused;
			try {
				localStorage.setItem(storageKey, manualPaused ? '1' : '0');
			} catch (e) {}
			syncPlaypauseAll();
		});
	}

	marquee.addEventListener('mouseenter', () => {
		hoverPaused = true;
	});
	marquee.addEventListener('mouseleave', () => {
		hoverPaused = false;
	});

	requestAnimationFrame(tick);
});
syncPlaypauseAll();
